import _ from 'lodash';

export function getDiff<T>(obj1: T, obj2: T): Partial<T> {
  let changedValues: Partial<T> = {};

  Object.keys(obj1 as any).forEach((key) => {
    const val1 = (obj1 as any)[key];
    const val2 = (obj2 as any)[key];

    // Handle arrays separately to preserve array structure
    if (_.isArray(val1) && _.isArray(val2)) {
      if (!_.isEqual(val1, val2)) {
        (changedValues as any)[key] = val2;
      }
    } else if (_.isObject(val1) && _.isObject(val2)) {
      const changes = getDiff(val1, val2);
      if (!_.isEmpty(changes)) {
        (changedValues as any)[key] = changes;
      }
    } else if (!_.isEqual(val1, val2)) {
      (changedValues as any)[key] = val2;
    }
  });

  Object.keys(obj2 as any).forEach((key) => {
    if (!(obj1 as any).hasOwnProperty(key) && !(changedValues as any).hasOwnProperty(key)) {
      (changedValues as any)[key] = (obj2 as any)[key];
    }
  });

  return changedValues;
}
